import {DataStatus} from 'platform/components';

import {useParams} from 'react-router-dom';

import {useGetQuickPresetQuery} from '@dms/api/settings';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {QuickPresetForm} from '../../components/QuickPresetForm';

export function Detail() {
  const {id: quickPresetId} = useParams();

  const quickPresetQuery = useGetQuickPresetQuery(
    {id: quickPresetId || ''},
    {skip: !quickPresetId}
  );

  return (
    <DataStatus isLoading={quickPresetQuery.isLoading} isError={quickPresetQuery.isError}>
      <SettingsTemplate
        header={{
          title: quickPresetQuery.data?.name || '',
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
            {
              label: i18n.t('page.settings.labels.advertisementPlatform'),
              href: settingsRoutes.advertisingPlatforms,
            },
            {
              label: i18n.t('page.settings.labels.advertisingQuickPresets.title'),
              href: settingsRoutes.advertisingQuickPresets,
            },
          ],
        }}
        data-testid={testIds.settings.advertisingQuickPresetsDetail()}
      >
        <QuickPresetForm />
      </SettingsTemplate>
    </DataStatus>
  );
}
